function Footer() {
  return (
    <div className="footer">
      ©
      <a className="portfolio-link" href="https://tomiwa-portfolio.netlify.app">
        Tomiwa
      </a>{" "}
      2023
    </div>
  );
}

export default Footer;
